import React, { useContext } from "react";
import { Modal, Heading, Flex, Button, StatusIcon } from "@cisco/spaces-dash-lib-styleguide";
import { I18nContext } from "../../../contexts/i18nContext";

export default function LocationDeletePopup(props) {
  const i18n = useContext(I18nContext);
  const { node, showDeletePopup, cancelDelete, deleteLocation } = props;

  return (
    <Modal size="sm" isOpen={showDeletePopup}>
      <Flex direction="vertical" gap={12}>
        <Flex align="center" gap={12}>
          <StatusIcon
            status="warning"
            style={{
              marginTop: -2
            }}
          />
          <Heading as="h2" size="primary">
            {i18n.t("business-location-details.delete-location-text")}
          </Heading>
        </Flex>
        <Modal.Content>
          <Flex justify="center" style={{ margin: "32px 0" }}>
            <div>
              {i18n.t("business-location-details.sure-want-to-delete-location-text")}:<strong>{` ${node?.data?.name}`}</strong>?
            </div>
          </Flex>
        </Modal.Content>
        <Flex justify="flex-end" style={{ width: "100%" }}>
          <Button.Group className="modal-footer">
            <Button kind="tertiary" onClick={cancelDelete}>
              {i18n.t("business-location-details.cancel-text")}
            </Button>
            <Button destructive onClick={deleteLocation}>
              {i18n.t("business-location-details.delete-text")}
            </Button>
          </Button.Group>
        </Flex>
      </Flex>
    </Modal>
  );
}
